export function fmtInt(v) {
  if (v == null) return "—";
  return Math.round(v).toLocaleString("ru-RU");
}

export function toNum(v) {
  if (v == null) return null;
  if (typeof v === "number") return Number.isNaN(v) ? null : v;
  if (typeof v === "string") {
    const s = v
      .replace(/\u00A0|\u202F/g, " ")
      .replace(/[%₽]/g, "")
      .replace(/\s+/g, "")
      .replace(",", ".");
    const n = Number(s);
    return Number.isNaN(n) ? null : n;
  }
  const n = Number(v);
  return Number.isNaN(n) ? null : n;
}

export function lastVal(arr) {
  if (!Array.isArray(arr) || arr.length === 0) return null;
  const v = Number(arr[arr.length - 1]);
  return Number.isNaN(v) ? null : v;
}

export function sumVal(arr) {
  if (!Array.isArray(arr) || arr.length === 0) return null;
  const nums = arr.map((v) => Number(v)).filter((n) => !Number.isNaN(n));
  if (!nums.length) return null;
  return nums.reduce((a, b) => a + b, 0);
}

export function avgVal(arr) {
  if (!Array.isArray(arr) || arr.length === 0) return null;
  const nums = arr.map((v) => Number(v)).filter((n) => !Number.isNaN(n));
  if (!nums.length) return null;
  return nums.reduce((a, b) => a + b, 0) / nums.length;
}

export function trendPct(arr) {
  if (!Array.isArray(arr) || arr.length < 2) return null;
  const last = toNum(arr[arr.length - 1]);
  const prev = toNum(arr[arr.length - 2]);
  if (last == null || prev == null || prev === 0) return null;
  return ((last - prev) / Math.abs(prev)) * 100;
}

export function makePaletteColors(palette, count) {
  const base = Array.isArray(palette) && palette.length ? palette : ["#0d6efd"];
  return Array.from({ length: count }, (_, i) => base[i % base.length]);
}

export function buildPieItems(labels, values, palette) {
  const lab = Array.isArray(labels) ? labels : [];
  const val = Array.isArray(values) ? values : [];
  const items = lab
    .map((label, idx) => ({ label: label ?? "—", value: toNum(val[idx]) ?? 0 }))
    .filter((x) => x.label != null && x.label !== "");
  items.sort((a, b) => b.value - a.value);
  const colors = makePaletteColors(palette, items.length);
  return items.map((it, i) => ({ ...it, color: colors[i] }));
}

export function sumNums(values) {
  if (!Array.isArray(values) || values.length === 0) return 0;
  return values
    .map(toNum)
    .filter((n) => n != null && Number.isFinite(n))
    .reduce((a, b) => a + b, 0);
}
